// M4 (Shale & Deepwater, 2000–2029) — tick hooks. Each workstream owns its own module and exports optional
// tickPre (before drilling: weather, services, markets that gate today's work), tickPost (after production:
// shale production, water, gas, oil sands) and tickEcon (end of day: finance, politics, fiscal, ESG, news/achievements).
// All are no-ops before 2000 (each module gates itself on rules.M4_FROM / feature dates).
import * as shale from './shale.js';     // workstream A: laterals, completions, type curves, pads/DUCs, services & water
import * as markets from './markets.js'; // workstream B: rig market, shale finance, hubs/takeaway/negative day, gas, fiscal, ESG
import * as world from './world.js';     // workstream C: deepwater/megaprojects, Macondo regime, politics, oil sands, news, QS
const MODS = [shale, markets, world];
const run = (k, state) => { for (const m of MODS) m[k]?.(state); };
export const tickM4Pre = (state) => run('tickPre', state);
export const tickM4Post = (state) => run('tickPost', state);
export const tickM4Econ = (state) => run('tickEcon', state);
